import type { ICustomer } from '../domain';
import { getSession } from './Session';

export const customerAttributes = {
	ExternalCustomer: 1,
	SyncProprietaryItems: 2,
	SyncDiscrepancies: 3,
	SpecIndicator: 4,
	AutoAddPhaseoutItems: 5,
	CustomCategories: 6,
	SyncSplits: 7,
	OgmAi: 10,
};

export const specIndicatorEnabled = () => {
	const session = getSession();
	return (
		session.customerAttributes.indexOf(customerAttributes.SpecIndicator) !== -1
	);
};

export const canManageAiSettings = () => {
	const session = getSession();
	return session.customerAttributes.indexOf(customerAttributes.OgmAi) !== -1;
};

export const customCategoriesEnabled = () => {
	const session = getSession();
	const hasCustomCategoriesEnabled =
		session.customerAttributes.indexOf(customerAttributes.CustomCategories) !==
		-1;
	const isSysco = session.siteTypeId === 1;
	return hasCustomCategoriesEnabled && isSysco;
};

export const umSelectionEnabled = () => {
	const session = getSession();
	const isDSSI = session.siteTypeId === 2;
	return isDSSI;
};

export const customer = (): ICustomer => {
	const session = getSession();

	return {
		id: session.customerId,
		name: session.customerName,
		attributes: session.customerAttributes,
		selectionRuleSets: session.customer?.selectionRuleSets,
	};
};
